import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';

import RightModalLayout from '../layouts/Modal/RightModalLayout';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';
import InputComponent from '../components/InputMC';
import FormProviderMC from '../components/FormProviderMC';
import SalesChannelModelMC from '../models/SalesChannelModelMC';

const CREATE_EDIT_VARIANT = {
  CREATE: 'CREATE',
  EDIT: 'EDIT'
};

const CreateEditSalesChannel = ({
  salesChannelSelected,
  VARIANT = CREATE_EDIT_VARIANT.CREATE,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('SalesChannels');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isCreateVariant = VARIANT === CREATE_EDIT_VARIANT.CREATE;
  const title = isCreateVariant
    ? t('sidebar.title.create')
    : t('sidebar.title.edit');

  const schema = object().shape({
    title: string().required(t('sidebar.title_required'))
  });

  const defaultValues = {
    title: salesChannelSelected?.title || ''
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  const handleSubmit = async (data) => {
    setIsSubmitting(true);

    const params = {
      sales_channel: {
        title: data.title
      }
    };

    try {
      if (isCreateVariant) {
        const response = await SalesChannelModelMC.save(params);
        showtoast(response.message || t('alerts.create_success'));
      } else {
        const response = await SalesChannelModelMC.save({ ...params, id: salesChannelSelected.web_id });
        showtoast(response.message || t('alerts.update_success'));
      }

      if (refetch) {
        refetch();
      }

      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
    } catch (error) {
      showtoast(error.message || t('alerts.error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  useEffect(() => {
    if (!isCreateVariant && salesChannelSelected) {
      methods.reset({
        title: salesChannelSelected.title
      });
    }
  }, [salesChannelSelected]);

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={title}
        submitAction={methods.handleSubmit(handleSubmit)}
        cancelAction={handleCancel}
        submitLabel={isCreateVariant ? t('sidebar.save') : t('sidebar.update')}
        cancelLabel={t('sidebar.cancel')}
        submitDisabled={isSubmitting}
      >
        <FormProviderMC methods={methods} onSubmit={methods.handleSubmit(handleSubmit)}>
          <div className="tw-flex tw-flex-col tw-gap-4">
            <InputComponent
              id="title"
              name="title"
              label={t('sidebar.title_label')}
              className="tw-resize-none"
              useFloatingLabel
            />
          </div>
        </FormProviderMC>
      </RightModalLayout>
    </div>
  );
};

export default CreateEditSalesChannel;
